import { WaitingOn } from '@taxfyle/api-internal/internal/job_pb'

/**
 * Job Waiting On Filter.
 */
export enum JobWaitingOnFilterOption {
  /**
   * Waiting on client
   */
  Client,
  /**
   * Waiting on provider
   */
  Provider,
}

/**
 * Checks if waiting on matches the waiting on filter.
 *
 * @param waitingOn
 * @param waitingOnFilter
 */
export function matchesWaitingOnFilter(
  waitingOn: WaitingOn | null,
  waitingOnFilter?: JobWaitingOnFilterOption,
) {
  if (waitingOnFilter === undefined) {
    return true
  }

  switch (waitingOnFilter) {
    case JobWaitingOnFilterOption.Client:
      return waitingOn === WaitingOn.WAITING_ON_CLIENT
    case JobWaitingOnFilterOption.Provider:
      return waitingOn === WaitingOn.WAITING_ON_PRO
    default:
      return false
  }
}
